<template>
  <div id="dashboard-analytics">
    <template v-if="$store.state.is_online && $store.state.is_mobile">
      <vs-alert class="mb-base text-center" color="success" v-if="$store.state.offline_ready === true">App is now ready to
        be used offline!</vs-alert>
      <vs-alert class="mb-base text-center" color="danger" v-else-if="$store.state.offline_ready === -1">An error occurred
        while synchornising app for offline usage. Please close app and open again to retry!</vs-alert>
      <vs-alert class="mb-base text-center" color="danger" v-else-if="$store.state.offline_ready === false">App is not
        ready to be used offline, synchronisation will start soon!</vs-alert>
      <vs-alert class="mb-base text-center" color="primary" v-else-if="$store.state.offline_ready === -2">App is
        synchronising for offline use. Please do not close the app until completed!</vs-alert>
    </template>
    <vs-alert class="mb-base text-center" color="danger" v-if="!$store.state.is_online && $store.state.is_mobile">You are
      in offline mode, some of the features are disabled.</vs-alert>
    <div>
      <template v-if="$store.state.is_online && seeOperationalDashboard">
        <!-- filters  -->
        <div class="fix-filters space-btw-charts mobile-margin-bottom">
          <vx-card>
            <vs-row>
              <!-- From Date  -->
              <vs-col vs-xs="6" vs-sm="5" vs-lg="2" class="px-0 pr-3">
                <SelectDate :selectedDate.sync="filters.from_date" label="Start Date" />
                <small class="block text-danger mt-1" v-if="api_errors && api_errors.from_date">
                  {{ api_errors.from_date.join(', ') }}
                </small>
              </vs-col>
              <!-- To Date  -->
              <vs-col vs-xs="6" vs-sm="5" vs-lg="2" class="px-0 pr-3 mobile_to_date">
                <SelectDate :selectedDate.sync="filters.to_date" label="End Date" />
                <small class="block text-danger mt-1" v-if="api_errors && api_errors.to_date">
                  {{ api_errors.to_date.join(', ') }}
                </small>
              </vs-col>
              <!-- Module Type  -->
              <vs-col vs-xs="12" vs-sm="10" vs-lg="4">
                <InputSelect :model.sync="filters.module_type" label="Module Type" placeholder="Choose"
                  container_class="w-auto d1-dropdown-alignment input-custom-dropdown" :options="module_type_options" :multiple="false" />
                <small class="block text-danger mt-1" v-if="api_errors && api_errors.module_type">
                  {{ api_errors.module_type.join(', ') }}
                </small>
              </vs-col>
              <!-- Road Incident Sub Type  -->
              <template v-if="filters.module_type == 'road_incident'">
                <vs-col vs-xs="12" vs-sm="10" vs-lg="4" :key="filters.module_type + 'ri'">
                  <InputSelect :model.sync="filters.road_incident_sub_type" label="Road Incident Sub Type"
                    placeholder="Choose" container_class="w-auto d1-dropdown-alignment input-custom-dropdown"
                    :options="road_incident_sub_type_options" :multiple="false" />
                </vs-col>
              </template>
              <!-- Major Maintenance Sub Type  -->
              <template v-else-if="filters.module_type == 'major_maintenance'">
                <vs-col vs-xs="12" vs-sm="10" vs-lg="4" :key="filters.module_type + 'mm'">
                  <InputSelect :model.sync="filters.major_maintenance_sub_type" label="Major Maintenance Sub Type"
                    placeholder="Choose" container_class="w-auto d1-dropdown-alignment input-custom-dropdown"
                    :options="major_maintenance_sub_type_options" :multiple="false" />
                </vs-col>
              </template>
            </vs-row>
          </vx-card>
        </div>
        <div style="width: 100%;">
          <!-- pie chart  -->
          <vs-row class="space-btw-charts">
            <vs-col class="mobile-margin-bottom" vs-xs="12" vs-sm="12" vs-lg="5">
              <vx-card class="widget">
                <template slot="no-body">
                  <div class="widget--heading">
                    <h5>Consolidated Incident</h5>
                  </div>
                </template>
                <div>
                  <PieChart :labels="pie_labels" :dataset="pie_data" :height="350"
                    :labels_background_color="pie_background_labels" legend_position="bottom" />
                </div>
              </vx-card>
            </vs-col>
            <!-- bar chart  -->
            <vs-col class="mobile-margin-bottom" vs-xs="12" vs-sm="12" vs-lg="7">
              <vx-card class="widget pb-3">
                <template slot="no-body">
                  <div class="widget--heading">
                    <h5>Month-Wise Incident</h5>
                  </div>
                </template>
                <BarChart legend_position="bottom" x_axis_title="Month/Year" y_axis_title="No. of Issues"
                  :labels_mode="bar_labels_mode" :labels="bar_labels" :dataset="bar_data" :stacked="true"
                  :labels_mode_background_color="background_labels" :height="340" />
              </vx-card>
            </vs-col>
          </vs-row>
          <!-- map chart  -->
          <vs-row class="space-btw-charts">
            <vs-col class="mobile-margin-bottom" vs-xs="12" vs-sm="12" vs-lg="12">
              <vx-card class="widget pb-3">
                <template slot="no-body">
                  <div class="widget--heading">
                    <h5>Incident plotted in Maps</h5>
                  </div>
                </template>
                <MapChart :data="map_markers"
                  @open_map_popup="data => open_map_popup(data)" />
              </vx-card>
            </vs-col>
          </vs-row>
        </div>
        <MapPopup class="sync-popup" :is_active.sync="map_popup.is_active" :data="map_popup.data" />
      </template>
      <template v-else>
        <div class="vx-col w-full mb-base">
          <vx-card slot="no-body" class="text-center bg-primary-gradient greet-user">
            <feather-icon icon="AwardIcon" class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow"
              svgClasses="h-8 w-8"></feather-icon>
            <h1 class="mb-6 text-white">Hello {{ $store.getters.userInfo.first_name }},</h1>
            <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">Welcome to Portal.</p>
          </vx-card>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import SelectDate from '../components/letstream/ls-select-date/SelectDate.vue'
import moment from 'moment'
import { Request } from '../utils/requests'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import BarChart from '../views/charts/BarChart.vue'
import PieChart from './charts/PieChart.vue'
import MapChart from './charts/MapChart.vue'
import MapPopup from './charts/MapPopup.vue'

export default {
  components: {
    BarChart,
    PieChart,
    SelectDate,
    MapChart,
    MapPopup
  },
  data() {
    let now = new Date();
    let current_year = now.getFullYear();

    return {
      
      issue_type: {
        routine_maintenance: 'Routine Maintenance',
        electrical_maintenance: 'Electrical Maintenance',
        major_maintenance: 'Major Maintenance',
        highway: 'Corrective Maintenance',
        road_user_accident: 'Road User Accident',
        occupational: 'Occupational',
        hazard: 'Hazard',
        dead_animal_debris_removal: 'Dead Animal Debris Removal',
        vehicle_breakdown: 'Vehicle Breakdown',
        traffic_violation: 'Traffic Violation',
        unauthorised_parking: 'Unauthorised Parking',
        unauthorised_access: 'Unauthorised Access',
        unauthorised_media_cut: 'Unauthorised Median Cut',
        material_damage: 'Material Damage',
        other: 'Other',
        enroachment_row: 'Enroachment Row',
      },

      module_type_options: [
        { value: 'routine_maintenance', label: 'Routine Maintenance' },
        { value: 'electrical_maintenance', label: 'Electrical Maintenance' },
        { value: 'major_maintenance', label: 'Major Maintenance' },
        { value: 'highway', label: 'Corrective Maintenance' },
        { value: 'road_incident', label: 'Road Incident' },
        { value: 'enroachment_row', label: 'Enroachment Row' },
        { value: 'safety_program', label: 'Safety Program' },
      ],

      road_incident_sub_type_options: [
        { value: 'road_user_accident', label: 'Road User Accident' },
        { value: 'occupational', label: 'Occupational' },
        { value: 'hazard', label: 'Hazard' },
        { value: 'dead_animal_debris_removal', label: 'Dead Animal Debris Removal' },
        { value: 'vehicle_breakdown', label: 'Vehicle Breakdown' },
        { value: 'traffic_violation', label: 'Traffic Violation' },
        { value: 'unauthorised_parking', label: 'Unauthorised Parking' },
        { value: 'unauthorised_access', label: 'Unauthorised Access' },
        { value: 'unauthorised_media_cut', label: 'Unauthorised Median Cut' },
        { value: 'material_damage', label: 'Material Damage' },
        { value: 'other', label: 'Other' },
      ],

      major_maintenance_sub_type_options: [
        { value: 'main_issue', label: 'Main Issue' },
        { value: 'mm_bituminous_concrete_overlay', label: 'Bituminous Concrete Overlay' },
        { value: 'mm_dense_bituminous_concrete_overlay', label: 'Dense Bituminous Concrete Overlay' },
        { value: 'mm_milling', label: 'Milling' },
        { value: 'mm_thermoplastic_road_marking', label: 'Thermoplastic RoadMarking' },
        { value: 'mm_shoulder_raising', label: 'Shoulder Raising' },
        { value: 'mm_road_sruds_fixing', label: 'RoadSruds Fixing' },
        { value: 'mm_kerb_topping', label: 'Kerb Topping' },
        { value: 'mm_kerb_painting', label: 'Kerb Painting/Crash Barrier' },
        { value: 'mm_microsurfacing', label: 'Micro Surfacing' },
        { value: 'mm_tack_coat', label: 'Tack Coat' },
      ],

      background_labels: {
        'created': '#F76801',
        'opened': '#4FA0FF',
        'closed': '#E49A2C',
        'rejected': '#C1CD39'
      },

      api_errors: {},

      filters: {
        from_date: moment(new Date(`${current_year}-01-01`)).format('YYYY-MM-DD'),
        to_date: moment(now).format('YYYY-MM-DD'),
        module_type: 'routine_maintenance',
        major_maintenance_sub_type: null,
        road_incident_sub_type: null,
      },

      map_popup: {
        is_active: false,
        data: {}
      },

      map_markers: [],

      // pie 
      pie_background_labels: [],
      pie_labels: [],
      pie_data: [],

      // bar
      bar_data: {},
      bar_labels: [],
      bar_labels_mode: {},
    }
  },
  computed: {
    rightIcon: () => faChevronRight,
    seeOperationalDashboard() {
      return this.hasAccess('read', 'operational_dashboard', 'all')
    }
  },
  watch: {
    filters: {
      deep: true,
      handler(newV) {
        this.load_data();
      }
    },
    'filters.module_type'() {
      this.clear_filter()
    }
  },
  mounted() {
    if(window.innerWidth >= 1200) {
      this.$store.commit('UPDATE_SIDEBAR_ITEMS_MIN', true)
      this.$store.commit('TOGGLE_REDUCE_BUTTON', true)
      this.$store.dispatch('updateSidebarWidth', 'reduced')
    }
    if (this.$store.state.is_online && this.seeOperationalDashboard) {
      this.load_data()
    }
  },
  beforeDestroy(){
    if(window.innerWidth >= 1200) {
      this.$store.commit('UPDATE_SIDEBAR_ITEMS_MIN', false)
      this.$store.commit('TOGGLE_REDUCE_BUTTON', false)
      this.$store.dispatch('updateSidebarWidth', 'default')
    }
  },
  methods: {
    validating_filters() {
      if (!this.filters.from_date) {
        this.api_errors = {
          "from_date": [
            "Date from is required.",
          ]
        }
        return true
      }
      if (!this.filters.to_date) {
        this.api_errors = {
          "to_date": [
            "Date to is required.",
          ]
        }
        return true
      }
      if (!this.filters.module_type) {
        this.api_errors = {
          "module_type": [
            "Module Type is required.",
          ]
        }
        return true
      }

      return false
    },
    load_data() {
      if (!this.validating_filters()) {
        this.load_map_data()
        this.load_pie_data()
        this.load_bar_data()
      }
    },
    // pie chart data
    load_pie_data() {

      let url = this.$store.state.apiendpoints.dashboard_stats_view1

      let payload = {
        'module_type': this.filters.module_type,
        'metric_type': 'pie_count',
      }

      payload['from_date'] = this.filters.from_date
      payload['to_date'] = this.filters.to_date

      if (this.filters.major_maintenance_sub_type) {
        payload['major_maintenance_sub_type'] = this.filters.major_maintenance_sub_type
      }

      if (this.filters.road_incident_sub_type) {
        payload['road_incident_sub_type'] = this.filters.road_incident_sub_type
      }

      Request(this, 'GET', url, payload).then(
        (res) => {
          this.pie_labels = res.chart_data.labels || []
          this.pie_data = res.chart_data.count
          this.set_bar_background_colors()
          this.api_errors = {}
        },
        (err) => {
          if (err.error) {
            this.api_errors = err.error
            this.$vs.notify({
              time: 2500,
              title: 'Error',
              text: (err.error && err.error.__non_field_errors__) ? err.error.__non_field_errors__.join(',') : 'An Error Occured. Please Try Again',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          } else {
            this.$vs.notify({
              time: 2500,
              title: 'Error',
              text: "Server error occured while loading charts. Please try again later.",
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          }
        }
      )
    },
    set_bar_background_colors() {
      for (let i = 0; i < this.pie_labels.length; i++) {
        let val = this.background_labels[this.pie_labels[i].toLowerCase()]
        this.pie_background_labels.push(val)
      }
    },
    // bar chart data
    load_bar_data() {

      let url = this.$store.state.apiendpoints.dashboard_stats_view1

      let payload = {
        'module_type': this.filters.module_type,
        'metric_type': 'bar_count',
      }

      payload['from_date'] = this.filters.from_date
      payload['to_date'] = this.filters.to_date

      if (this.filters.major_maintenance_sub_type) {
        payload['major_maintenance_sub_type'] = this.filters.major_maintenance_sub_type
      }

      if (this.filters.road_incident_sub_type) {
        payload['road_incident_sub_type'] = this.filters.road_incident_sub_type
      }

      Request(this, 'GET', url, payload).then(
        (res) => {
          this.bar_labels = res.chart_data.labels || []

          let data = {
            'opened': res.chart_data.opened || [],
            'closed': res.chart_data.closed || [],
            'rejected': res.chart_data.rejected || [],
            'created': res.chart_data.created || []
          }

          this.bar_data = data

          let labels_mode = {
            'opened': 'Opened',
            'closed': 'Closed',
            'rejected': 'Rejected',
            'created': 'Created',
          }

          this.bar_labels_mode = labels_mode
          this.api_errors = {}
        },
        (err) => {

          if (err.error) {
            this.api_errors = err.error
            this.$vs.notify({
              time: 2500,
              title: 'Error',
              text: (err.error && err.error.__non_field_errors__) ? err.error.__non_field_errors__.join(',') : 'An Error Occured. Please Try Again',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          } else {
            this.$vs.notify({
              time: 2500,
              title: 'Error',
              text: "Server error occured while loading charts. Please try again later.",
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          }
        }
      )
    },
    // map data
    load_map_data() {
      let url = this.$store.state.apiendpoints.dashboard_stats_view1

      let payload = {
        'module_type': this.filters.module_type,
        'metric_type': 'map_chart',
      }

      payload['from_date'] = this.filters.from_date
      payload['to_date'] = this.filters.to_date

      if (this.filters.major_maintenance_sub_type) {
        payload['major_maintenance_sub_type'] = this.filters.major_maintenance_sub_type
      }

      if (this.filters.road_incident_sub_type) {
        payload['road_incident_sub_type'] = this.filters.road_incident_sub_type
      }

      Request(this, 'GET', url, payload).then(
        (res) => {
          this.map_markers = res.chart_data.map_data || []
        },
        (err) => {
          if (err.error) {
            this.api_errors = err.error
            this.$vs.notify({
              time: 2500,
              title: 'Error',
              text: (err.error && err.error.__non_field_errors__) ? err.error.__non_field_errors__.join(',') : 'An Error Occured. Please Try Again',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          } else {
            this.$vs.notify({
              time: 2500,
              title: 'Error',
              text: "Server error occured while loading charts. Please try again later.",
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          }
        }
      )
    },
    open_map_popup(data) {
      this.map_popup.data = data
      this.map_popup.is_active = true
    },
    clear_filter() {
      this.filters.road_incident_sub_type = null
      this.filters.major_maintenance_sub_type = null
    }
  }
}
</script>

<style lang="scss">

@mixin mobile {
  @media only screen and (max-width: 768px) {
      @content;
  }
}

#dashboard-analytics {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }

    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media(max-width: 576px) {

    .decore-left,
    .decore-right {
      width: 140px;
    }
  }

  @include mobile {
    .space-btw-charts {
      margin-bottom: 0 !important;
    }

    .d1-dropdown-alignment {
      .vs--single .vs__selected {
        max-width: 45vw !important;
      }
    }

    .vs-col {
      padding: 0px 6px !important;
    } 
    
    .mobile_to_date {
      .vdp-datepicker__calendar {
        margin-left: -40vw
      }
    }
  }

  .mobile-margin-bottom {
    @include mobile {
      margin-bottom: 3vh !important;   
    }
  }
  
}

.dashboard-card {
  &--icon {
    img {
      height: 50px;
    }
  }

  &--content {
    display: flex;
    flex-direction: column;

    h4 {
      font-size: 1.1em;
      font-weight: bold;
      margin: 0;
      margin-top: 10px;
    }
  }
}

.d1-dropdown-alignment {
  .vs--single .vs__selected {
      overflow: hidden !important;
      max-width: 15vw !important;
      white-space: nowrap !important;
  }

  .vs__selected-options {
    flex-wrap: nowrap;
  }
}

.widget {
  border-radius: 12px;

  .vx-card__header {
    padding-top: 0;
  }

  &--heading {
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    padding: 10px 10px;
    display: flex;
    align-items: center;
    background-color: #CDCDCD;

    h5 {
      display: inline-flex;
      margin: 0;
      flex-grow: 1;
    }

    .right {
      .input-custom-dropdown .vs__dropdown-toggle {
        min-width: 170px;
        background-color: white;
      }
    }
  }
}

.pie-data-alignment-d0 {
  display: flex;
  flex-direction: column;
  margin: 0px 5px;
  align-items: center;

  .count-d0 {
    width: 70px;
    height: 40px;
    border-radius: 3px;
    color: #fff;
    margin-bottom: 18px;
    padding: 5px 5px;
    font-weight: 600 !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .title-d0 {
    padding: 0px 10px;
    margin-bottom: 3px;
    width: 80px;
    height: 55px;
    display: flex;
    align-items: center;
    justify-content: left;
    font-weight: 600 !important;
    font-size: 16px;
  }
}

.space-btw-charts {
  margin-bottom: 5vh;
}
</style>
<style type="text/css" media="screen, projection">
@import url(https://s3.amazonaws.com/assets.freshdesk.com/widget/freshwidget.css);
</style>